export default {
  pageSize: state => state.pageSize,
  searchTerm: state => state.searchTerm,
  filterOptions: state => state.filterOptions,
  filterBy: state => state.filterBy,
  sortDir: state => state.sortDir,
  orderBy: state => state.orderBy,
  locationTree: state => state.locationTree,
  networkTree: state => state.networkTree,
  locations: state => state.locations,
  location: state => state.location,
  locationsFound: state => state.locationsFound,
  preferences: state => state.preferences,
  currentLocation: state => state.currentLocation,
  emailTemplate: state => state.emailTemplate,
  dispatchedTechs: state => state.dispatchedTechs,
  outnetwork: state => state.outnetwork,
  locationFilter: state => state.locationFilter,
  showAll: state => state.showAll,
  insuranceFound: state => state.insuranceFound,
  insurance: state => state.insurance
}



// WEBPACK FOOTER //
// ./src/store/modules/locations/getters.js